// extracted by mini-css-extract-plugin
export default {"icons":"GuaranteeCard_icons__DACJm","greyText":"GuaranteeCard_greyText__SXJRD"};